import { type AuditLogPage, type AuditTargetType, auditLogPageDto } from '@planuze/admin-contracts';
import { buildQuery, mapHttpError, parseJson, request } from './http.js';

/* Cliente REST da trilha de auditoria (ADR-0708). Reusa os helpers compartilhados do `http.ts`
   (`request`/`buildQuery`/`parseJson`/`mapHttpError`) — sem plumbing local. `actorId`/`targetId`
   são filtros de igualdade exata; `action`/`targetType` são filtros de igualdade server-side;
   `q` é busca livre (ILIKE "contém") sobre `action`+`targetId`; `from`/`to` são a janela do período. */

export interface AuditQuery {
  readonly actorId?: string | undefined;
  readonly targetType?: AuditTargetType | undefined;
  readonly action?: string | undefined;
  readonly targetId?: string | undefined;
  readonly q?: string | undefined;
  readonly from?: string | undefined;
  readonly to?: string | undefined;
  readonly cursor?: string | undefined;
  readonly limit?: number | undefined;
}

/** GET /v1/admin/audit-log — página keyset da trilha (filtros server-side + cursor). */
export async function listAuditLog(query: AuditQuery): Promise<AuditLogPage> {
  const res = await request(
    `/v1/admin/audit-log${buildQuery({
      actorId: query.actorId,
      targetType: query.targetType,
      action: query.action,
      targetId: query.targetId,
      q: query.q,
      from: query.from,
      to: query.to,
      cursor: query.cursor,
      limit: query.limit,
    })}`,
  );
  if (!res.ok) throw await mapHttpError(res);
  return parseJson(res, auditLogPageDto);
}
